module.exports = __webpack_public_path__ + "media/static/icons/icon-tide-star-a749f8b78f09612bc22c363895bd242e.svg";